import { Component, Input, OnInit } from '@angular/core';
import {Config} from '@vendor/config/config';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() imgSrc = 'assets/img/EnBankLogo_whiteText.png';
  @Input() showVersion = true;
  appVersion = this.confog.version;
  constructor(private confog: Config) { }
  ngOnInit() {
  }
}
